import React from 'react';
import { observer } from 'mobx-react-lite';
import { BasePieChart } from './base/pie/base-pie-chart';
import { useRootStore } from '../../../providers/root-store-provider';
import { PieChartTypeEnum } from '../../../models/enums/pie-chart-type-enum';

type BrokerChartType = {
    isFullScreen?: boolean;
};

export const BrokerChart: React.FC<BrokerChartType> = observer(({ isFullScreen }: BrokerChartType) => {
    const { portfolioStore } = useRootStore();
    const { brokerRatio } = useRootStore().statisticStore.ratiosStore;

    if (!brokerRatio) {
        return null;
    }

    return (
        <BasePieChart
            currency={portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode}
            type={PieChartTypeEnum.Broker}
            data={brokerRatio.data}
            isFullScreen={isFullScreen}
        />
    );
});
